import styled from 'styled-components';

export { default as RegisterStudent } from './register-student';
export { default as RegisterGuardian } from './register-guardian';
export { default as RegisterTeacher } from './register-teacher';

export const EducationalInput = styled.input`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.gray_300};
  border-radius: 4px;
  outline: none;

  color: ${({ theme }) => theme.colors.gray_600};

  &::placeholder {
    opacity: 0.5;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      padding: 0.8rem;
      font-size: 0.8rem;

      ${mediaQueries.desktop} {
        padding: 1rem;
        font-size: 1rem;
      }
    `;
  }}
`;
